import Cookies from "js-cookie";
export const checkCookies = () => {
  const domain =
    process.env.NODE_ENV === "development" ? "localhost" : ".mudey.pt";
  const companyId = Cookies.get("MUDEY_company");
  if (companyId) return companyId;
  else return "Mudey";
};
